import { render, staticRenderFns } from "./TXstudentIndex.vue?vue&type=template&id=31a1212d&scoped=true"
import script from "./TXstudentIndex.vue?vue&type=script&lang=js"
export * from "./TXstudentIndex.vue?vue&type=script&lang=js"
import style0 from "./TXstudentIndex.vue?vue&type=style&index=0&id=31a1212d&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a1212d",
  null
  
)

export default component.exports